import { useState, useEffect, useRef } from 'react';
import Explainer from '../blocks';
import cn from 'classnames';

const EXPLANER_WIDTH = 628;
const EXPLANER_HEIGHT = 340;
const TIME = 4;
const FIRST_TIME = TIME / 2;
const EASE = 0.25;

import styles from './ScanningPackageAnalysis.module.css';

const iconsMap = {
  0: {
    title: 'docker',
    result: {
      color: 'orange',
      value: 1,
    },
    svg: (
      <g>
        <path
          d="M25.3486 22.3065H26.9429C26.9799 22.3065 27.0153 22.2918 27.0416 22.2657C27.0678 22.2397 27.0826 22.2043 27.0828 22.1673V20.7476C27.0828 20.7105 27.068 20.6749 27.0418 20.6486C27.0156 20.6224 26.98 20.6076 26.9429 20.6076H25.3486C25.3117 20.6076 25.2762 20.6223 25.2502 20.6484C25.224 20.6745 25.2094 20.7099 25.2094 20.7468V22.1673C25.2094 22.2441 25.2718 22.3065 25.3486 22.3065ZM23.126 18.2211H24.7196C24.7567 18.2211 24.7923 18.2064 24.8185 18.1801C24.8448 18.1539 24.8596 18.1183 24.8596 18.0812V16.6607C24.8594 16.6237 24.8445 16.5883 24.8183 16.5622C24.7921 16.5361 24.7565 16.5215 24.7196 16.5215H23.126C23.0891 16.5215 23.0538 16.5362 23.0276 16.5623C23.0015 16.5884 22.9869 16.6238 22.9869 16.6607V18.0812C22.9869 18.1579 23.0486 18.2211 23.126 18.2211ZM23.126 20.2638H24.7196C24.7566 20.2636 24.7921 20.2488 24.8184 20.2226C24.8445 20.1964 24.8594 20.1609 24.8596 20.1238V18.7041C24.8594 18.6671 24.8445 18.6317 24.8183 18.6057C24.7921 18.5796 24.7565 18.5649 24.7196 18.5649H23.126C23.0891 18.5649 23.0538 18.5796 23.0276 18.6057C23.0015 18.6318 22.9869 18.6672 22.9869 18.7041V20.1238C22.9869 20.2006 23.0486 20.263 23.126 20.2638ZM20.9216 20.2638H22.5166C22.5535 20.2634 22.5887 20.2485 22.6147 20.2223C22.6405 20.1961 22.6551 20.1607 22.6551 20.1238V18.7041C22.6551 18.6672 22.6404 18.6318 22.6143 18.6057C22.5882 18.5796 22.5529 18.5649 22.5159 18.5649H20.9224C20.8855 18.5649 20.85 18.5796 20.8239 18.6057C20.7978 18.6318 20.7832 18.6672 20.7832 18.7041V20.1238C20.7832 20.2006 20.8449 20.263 20.9216 20.2638ZM18.6923 20.2638H20.2866C20.3236 20.2636 20.359 20.2488 20.3851 20.2225C20.4112 20.1963 20.4258 20.1608 20.4258 20.1238V18.7041C20.4258 18.6672 20.4111 18.6318 20.385 18.6057C20.3589 18.5796 20.3235 18.5649 20.2866 18.5649H18.6923C18.6554 18.5649 18.6199 18.5796 18.5936 18.6057C18.5674 18.6317 18.5526 18.6671 18.5524 18.7041V20.1238C18.5524 20.2006 18.6156 20.263 18.6923 20.2638ZM23.126 22.3065H24.7196C24.7565 22.3065 24.7921 22.2918 24.8183 22.2657C24.8445 22.2397 24.8594 22.2043 24.8596 22.1673V20.7476C24.8596 20.7105 24.8448 20.6749 24.8185 20.6486C24.7923 20.6224 24.7567 20.6076 24.7196 20.6076H23.126C23.0891 20.6076 23.0538 20.6223 23.0276 20.6484C23.0015 20.6745 22.9869 20.7099 22.9869 20.7468V22.1673C22.9869 22.2441 23.0486 22.3065 23.126 22.3065ZM20.9216 22.3065H22.5166C22.5534 22.3063 22.5886 22.2915 22.6146 22.2655C22.6405 22.2394 22.6551 22.2041 22.6551 22.1673V20.7476C22.6552 20.7293 22.6517 20.7112 22.6448 20.6942C22.6379 20.6773 22.6277 20.6619 22.6149 20.6489C22.602 20.6359 22.5867 20.6256 22.5698 20.6185C22.553 20.6114 22.5349 20.6077 22.5166 20.6076H20.9216C20.8848 20.6078 20.8496 20.6226 20.8237 20.6487C20.7977 20.6747 20.7832 20.71 20.7832 20.7468V22.1673C20.7832 22.2441 20.8449 22.3065 20.9216 22.3065ZM18.6923 22.3065H20.2866C20.3235 22.3065 20.3589 22.2918 20.385 22.2657C20.4111 22.2396 20.4258 22.2042 20.4258 22.1673V20.7476C20.4259 20.7293 20.4224 20.7112 20.4155 20.6942C20.4086 20.6773 20.3984 20.6619 20.3856 20.6489C20.3727 20.6359 20.3574 20.6256 20.3406 20.6185C20.3237 20.6114 20.3056 20.6077 20.2874 20.6076H18.6923C18.6552 20.6076 18.6196 20.6224 18.5934 20.6486C18.5671 20.6749 18.5524 20.7105 18.5524 20.7476V22.1673C18.5524 22.2441 18.6156 22.3065 18.6923 22.3065ZM16.4954 22.3065H18.0904C18.1272 22.3063 18.1624 22.2915 18.1884 22.2655C18.2143 22.2394 18.2289 22.2041 18.2289 22.1673V20.7476C18.229 20.7293 18.2255 20.7112 18.2186 20.6942C18.2117 20.6773 18.2015 20.6619 18.1886 20.6489C18.1758 20.6359 18.1605 20.6256 18.1436 20.6185C18.1268 20.6114 18.1087 20.6077 18.0904 20.6076H16.4954C16.4586 20.6078 16.4234 20.6226 16.3975 20.6487C16.3715 20.6747 16.357 20.71 16.357 20.7468V22.1673C16.357 22.2441 16.4179 22.3065 16.4954 22.3065ZM32.7068 21.4126C32.6579 21.3743 32.2012 21.029 31.2367 21.029C30.9824 21.0297 30.728 21.0515 30.4767 21.0944C30.2901 19.8154 29.2331 19.1909 29.1857 19.1638L28.9269 19.0141L28.7568 19.2601C28.5432 19.5897 28.3881 19.9538 28.2963 20.336C28.1234 21.0658 28.2287 21.752 28.5996 22.3381C28.1519 22.5878 27.4335 22.6488 27.2874 22.6541H15.3932C15.2438 22.6543 15.1007 22.7136 14.9949 22.8191C14.8892 22.9245 14.8295 23.0675 14.8289 23.2169C14.815 24.2588 14.9914 25.2945 15.3495 26.273C15.7596 27.3474 16.369 28.1389 17.1628 28.6234C18.0506 29.1674 19.4951 29.4788 21.1316 29.4788C21.8711 29.4811 22.6084 29.4141 23.336 29.2787C24.3463 29.0931 25.3185 28.74 26.2123 28.2337C26.9496 27.8071 27.6117 27.2646 28.176 26.6266C29.118 25.5597 29.6792 24.3718 30.0969 23.3162H30.2631C31.2953 23.3162 31.9296 22.9031 32.2795 22.5571C32.512 22.3366 32.6933 22.0679 32.8113 21.7701L32.8851 21.5533L32.7068 21.4126Z"
          fill="white"
          fillOpacity="0.75"
        />
      </g>
    ),
  },
  1: {
    title: 'helm',
    result: {
      color: 'green',
      value: 0,
    },
    svg: (
      <g>
        <path
          d="M89.2624 13.7012C88.8943 13.7012 88.5953 14.4885 88.5953 15.4594C88.5953 15.8678 88.6487 16.2428 88.7371 16.5412C87.6517 16.5987 86.5973 16.9234 85.6677 17.4866C85.5482 17.1869 85.3935 16.9025 85.2066 16.6396C84.737 15.9685 84.1682 15.5268 83.8195 15.5315C83.7596 15.5311 83.7009 15.5489 83.6514 15.5826C83.3492 15.7942 83.5561 16.6101 84.1132 17.406C84.3201 17.7012 84.5464 17.9523 84.7641 18.1406C84.3123 18.5294 83.9141 18.9766 83.5801 19.4703H84.9238C85.4462 18.88 86.0881 18.4075 86.807 18.0841C87.5258 17.7607 88.3053 17.5937 89.0935 17.5943C89.8818 17.5935 90.6613 17.7603 91.3803 18.0836C92.0993 18.4069 92.7414 18.8793 93.264 19.4695H94.6069C94.3132 19.0359 93.97 18.638 93.584 18.2839C93.8553 18.091 94.1536 17.7857 94.4194 17.406C94.9765 16.6101 95.1834 15.7942 94.8812 15.5826C94.8315 15.5492 94.773 15.5317 94.7131 15.5322C94.3643 15.5268 93.7956 15.9685 93.326 16.6404C93.1001 16.9539 92.9235 17.3002 92.8021 17.6671C91.9011 17.0569 90.8632 16.6789 89.7808 16.5667C89.8739 16.2645 89.9304 15.8794 89.9304 15.4594C89.9304 14.4885 89.6313 13.7012 89.2624 13.7012ZM80.9609 21.0185V25.0186H82.0133V23.4936H83.2841V25.0186H84.3356V21.0185H83.2825V22.4428H82.0117V21.0185H80.9609ZM85.5421 21.0185V25.0186H88.0295V24.1599H86.5937V23.4238H87.8645V22.5389H86.5937V21.888H88.0295V21.0185H85.5421ZM89.1826 21.0185V25.0186H91.6762V23.9632H90.235V21.0185H89.1826ZM92.8293 21.0185V25.0186H93.8862V22.9705L94.9378 23.9198L95.9839 22.9651V25.0186H97.0416V21.0185H96.5658L94.9386 22.5017L93.3043 21.0185H92.8293ZM83.67 26.6598C83.985 27.1023 84.3524 27.5051 84.7641 27.8594C84.5178 28.0767 84.299 28.3234 84.1125 28.5939C83.5553 29.3897 83.3492 30.2058 83.6506 30.4173C83.9528 30.6289 84.6495 30.1554 85.2058 29.3603C85.3926 29.0976 85.5474 28.8135 85.6669 28.5141C86.5966 29.077 87.651 29.4014 88.7363 29.4587C88.6383 29.8108 88.5906 30.175 88.5945 30.5405C88.5945 31.5114 88.8936 32.2988 89.2617 32.2988C89.6305 32.2988 89.9296 31.5114 89.9296 30.5405C89.9296 30.1205 89.8739 29.7346 89.78 29.4324C90.8628 29.3204 91.9009 28.9423 92.8021 28.332C92.896 28.642 93.075 29.0023 93.3252 29.3603C93.8824 30.1554 94.5782 30.6289 94.8805 30.4173C95.1826 30.2058 94.9757 29.3897 94.4186 28.5939C94.1528 28.2143 93.8553 27.9082 93.584 27.7144C93.9305 27.3966 94.2426 27.0434 94.5155 26.6606H93.1431C92.6227 27.2124 91.9949 27.6518 91.2984 27.952C90.6018 28.2521 89.8512 28.4065 89.0927 28.4056C88.3344 28.4064 87.5839 28.2519 86.8875 27.9518C86.1911 27.6517 85.5634 27.2123 85.0431 26.6606L83.67 26.6598Z"
          fill="white"
          fillOpacity="0.75"
        />
      </g>
    ),
  },
  2: {
    title: 'rubygems',
    result: {
      color: 'red',
      value: 15,
    },
    svg: (
      <g>
        <path
          d="M151.912 19.9642L151.902 19.9546L149.72 22.0821L155.019 27.2379L157.202 25.1199L160.319 22.0821L158.136 19.9547V19.945H151.902L151.912 19.9642Z"
          fill="white"
          fillOpacity="0.75"
        />
        <path
          d="M154.999 14.2812L147.281 18.5937V27.2186L154.999 31.531L162.718 27.2186V18.5937L154.999 14.2812ZM161.243 26.3944L154.999 29.9019L148.756 26.3944V19.3987L154.999 15.8912L161.243 19.3987V26.3944Z"
          fill="white"
          fillOpacity="0.75"
        />
      </g>
    ),
  },
  3: {
    title: 'redhat',
    result: {
      color: 'orange',
      value: 2,
    },
    svg: (
      <g>
        <path
          d="M224.151 24.4666C225.387 24.4666 227.177 24.2094 227.177 22.7362C227.177 22.6234 227.167 22.5111 227.147 22.4L226.415 19.1963C226.247 18.4944 226.099 18.168 224.863 17.555C223.904 17.0605 221.818 16.2598 221.194 16.2598C220.611 16.2598 220.443 17.0014 219.761 17.0014C219.098 17.0014 218.614 16.4475 217.991 16.4475C217.398 16.4475 217.012 16.8529 216.715 17.6836C216.715 17.6836 215.885 20.027 215.776 20.373C215.76 20.4342 215.753 20.4977 215.756 20.561C215.746 21.4704 219.336 24.4565 224.151 24.4666ZM227.364 23.3394C227.532 24.1503 227.532 24.2391 227.532 24.338C227.532 25.722 225.98 26.4934 223.933 26.4934C219.306 26.4934 215.262 23.7844 215.262 21.9946C215.262 21.7464 215.312 21.5008 215.41 21.2729C213.749 21.3519 211.594 21.6486 211.594 23.547C211.594 26.6615 218.97 30.4979 224.804 30.4979C229.283 30.4979 230.41 28.4708 230.41 26.8693C230.41 25.6136 229.322 24.1898 227.364 23.3394Z"
          fill="white"
          fillOpacity="0.75"
        />
      </g>
    ),
  },
  4: {
    title: 'python',
    result: {
      color: 'green',
      value: 0,
    },
    svg: (
      <g>
        <path
          d="M286.897 14.3751C286.186 14.3784 285.507 14.4384 284.909 14.543C283.148 14.8507 282.829 15.4946 282.829 16.6822V18.2506H286.989V18.7734H281.267C280.058 18.7734 278.999 19.4923 278.668 20.8599C278.286 22.4274 278.269 23.4056 278.668 25.0423C278.964 26.2606 279.67 27.1288 280.879 27.1288H282.31V25.2485C282.31 23.8903 283.498 22.6921 284.909 22.6921H289.065C290.222 22.6921 291.145 21.7499 291.145 20.6009V16.6822C291.145 15.5669 290.194 14.7291 289.065 14.543C288.35 14.4253 287.609 14.3719 286.897 14.3751ZM284.647 15.6366C285.077 15.6366 285.428 15.9894 285.428 16.4232C285.428 16.8555 285.077 17.205 284.647 17.205C284.216 17.205 283.866 16.8555 283.866 16.4232C283.866 15.9894 284.216 15.6366 284.647 15.6366Z"
          fill="white"
          fillOpacity="0.75"
        />
        <path
          d="M291.664 18.7735V20.6009C291.664 22.0177 290.45 23.2102 289.065 23.2102H284.909C283.771 23.2102 282.829 24.1739 282.829 25.3014V29.2201C282.829 30.3354 283.809 30.9913 284.909 31.3113C286.226 31.6943 287.489 31.7636 289.065 31.3113C290.112 31.0113 291.145 30.4076 291.145 29.2201V27.6517H286.989V27.1288H293.226C294.435 27.1288 294.886 26.2946 295.306 25.0424C295.74 23.7533 295.722 22.5136 295.306 20.8599C295.007 19.6693 294.436 18.7735 293.226 18.7735H291.664ZM289.327 28.6973C289.758 28.6973 290.108 29.0468 290.108 29.4791C290.108 29.9128 289.758 30.2657 289.327 30.2657C288.897 30.2657 288.546 29.9128 288.546 29.4791C288.546 29.0468 288.897 28.6973 289.327 28.6973Z"
          fill="white"
          fillOpacity="0.75"
        />
      </g>
    ),
  },
  5: {
    title: 'npm',
    result: {
      color: 'red',
      value: 24,
    },
    svg: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M360.665 15.334H345.332V30.6673H360.665V15.334ZM357.599 18.0173H348.399V27.984H352.999V20.3173H355.299V27.984H357.599V18.0173Z"
          fill="white"
          fillOpacity="0.75"
        />
      </g>
    ),
  },
};

const Package = ({ index, icon, status = 0 }) => {
  const initialXPos = 66;
  const scannerRef = useRef(null);

  const x = -5;
  const y = -20;

  return (
    <g datatitle={icon.title}>
      <g className={cn(styles.package)}>
        <rect
          x={`${initialXPos * index}`}
          width="46"
          height="46"
          rx="6"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          className={cn(styles.packageLabel, {
            [styles.packageLabelActive]: status === 1,
          })}
          x={`${initialXPos * index}`}
          width="46"
          height="46"
          rx="6"
          fill="var(--brand-color-blue-7)"
        />
        {icon.svg}
      </g>

      <g
        ref={scannerRef}
        className={cn(styles.packageScanner, {
          [styles.packageScannerActive]: status === 1,
        })}
      >
        <g>
          <rect
            filter={`url(#filter_0${index})`}
            x={`${initialXPos * index + x}`}
            y={`${y}`}
            width="56"
            height="2"
            rx="1"
            fill="#2A6FE1"
          />
        </g>
        <defs>
          <filter
            id={`filter_0${index}`}
            x={`${initialXPos * index + x}`}
            y={`${y}`}
            width="72"
            height="18"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="4" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.164706 0 0 0 0 0.435294 0 0 0 0 0.882353 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2925_15169"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2925_15169"
              result="shape"
            />
          </filter>
        </defs>
      </g>
    </g>
  );
};

const StatusMonitor = ({ status, headline }) => {
  const colorFill =
    status === 'scanning'
      ? 'var(--brand-color-blue-6)'
      : status === 'green'
      ? 'var(--brand-color-green-5)'
      : status === 'orange'
      ? 'var(--brand-color-yellow-5)'
      : status === 'red'
      ? 'var(--brand-color-red-7)'
      : 'var(--brand-color-blue-6)';

  return (
    <g className={cn(styles.statusMonitor)} mask="url(#roundedMask)">
      <rect width="313" height="128" rx="6" fill="white" fillOpacity="0.1" />
      <path
        className={cn(styles.statusRibbon)}
        d="M0 0H6V128H0V0Z"
        fill={colorFill}
      />
      <text
        className={cn(styles.textDefault, {
          [styles.textDefaultActive]: status === 'scanning',
        })}
        x="24"
        y="104"
        fill="white"
        fontSize="14"
        fontFamily="var(--font-family-body)"
      >
        Scanning...
      </text>
      <text
        className={cn(styles.textCustom, {
          [styles.textCustomActive]:
            status === 'green' || status === 'orange' || status === 'red',
        })}
        x="24"
        y="116"
        fill="white"
        fontSize="14"
        fontFamily="var(--font-family-body)"
      >
        Vulnerabilities found
      </text>
      <g
        className={cn(styles.iconDefault, {
          [styles.iconDefaultActive]:
            status === 'green' || status === 'orange' || status === 'red',
        })}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.4704 54.5098H31.3909L28.5241 57.3766V62.1901H45.4774V57.3766L42.6105 54.5098H40.2266H38.4704ZM47.8524 62.1901V56.3929L43.5942 52.1348H40.2266H38.4704H30.4072L26.1491 56.3929V62.1901H21.4492V64.5651H52.5519V62.1901H47.8524ZM38.4704 73.4896H31.3908L28.5239 70.6227V67.2041H26.1489V71.6064L30.407 75.8646H38.4704H39.4757H43.5942L47.8523 71.6064V67.2041H45.4773V70.6227L42.6104 73.4896H39.4757H38.4704Z"
          fill="#2A6FE1"
        />
      </g>
      <g
        className={cn(styles.iconGreen, {
          [styles.iconGreenActive]: status === 'green',
        })}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9727 98.6424L33.6444 88.9707L40.3586 88.9707L50.0303 98.6424V105.357L40.3586 115.028H33.6444L23.9727 105.357V98.6424ZM26.3477 99.6262V104.373L34.6281 112.653H39.3748L47.6553 104.373V99.6262L39.3748 91.3457L34.6281 91.3457L26.3477 99.6262Z"
          fill="#1BB694"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.5827 98.7357L37.2385 106.367H35.0229L31.4203 102.417L33.0739 100.817L35.9701 103.992H36.0888L40.7239 97.3734L42.5827 98.7357Z"
          fill="#1BB694"
        />
      </g>
      <g
        className={cn(styles.iconOrange, {
          [styles.iconOrangeActive]: status === 'orange',
        })}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9727 98.6424L33.6444 88.9707L40.3586 88.9707L50.0303 98.6424V105.357L40.3586 115.028H33.6444L23.9727 105.357V98.6424ZM26.3477 99.6262V104.373L34.6281 112.653H39.3748L47.6553 104.373V99.6262L39.3748 91.3457L34.6281 91.3457L26.3477 99.6262Z"
          fill="#D8982A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.9265 103.634L35.5548 99.3604L35.5539 95.2361L35.8751 94.9149L38.1786 94.9149L38.4998 95.2361L38.5007 99.3398L38.1273 103.634L37.8145 103.947L36.2393 103.947L35.9265 103.634ZM35.6677 108.609L35.3465 108.288V105.724L35.6677 105.403L38.3353 105.403L38.6565 105.724V108.288L38.3353 108.609L35.6677 108.609Z"
          fill="#D8982A"
        />
      </g>
      <g
        className={cn(styles.iconRed, {
          [styles.iconRedActive]: status === 'red',
        })}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9727 98.6424L33.6444 88.9707L40.3586 88.9707L50.0303 98.6424V105.357L40.3586 115.028H33.6444L23.9727 105.357V98.6424ZM26.3477 99.6262V104.373L34.6281 112.653H39.3748L47.6553 104.373V99.6262L39.3748 91.3457L34.6281 91.3457L26.3477 99.6262Z"
          fill="#B73B55"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.9265 103.634L35.5548 99.3604L35.5539 95.2361L35.8751 94.9149L38.1786 94.9149L38.4998 95.2361L38.5007 99.3398L38.1273 103.634L37.8145 103.947L36.2393 103.947L35.9265 103.634ZM35.6677 108.609L35.3465 108.288V105.724L35.6677 105.403L38.3353 105.403L38.6565 105.724V108.288L38.3353 108.609L35.6677 108.609Z"
          fill="#B73B55"
        />
      </g>
      <text
        className={cn(styles.headingDefault, {
          [styles.headingDefaultActive]:
            status === 'green' || status === 'orange' || status === 'red',
        })}
        x="64"
        y="77"
        fill={colorFill}
        fontSize="40"
        fontFamily="var(--font-family-mono)"
      >
        {headline}
      </text>
      <defs>
        <mask
          id="roundedMask"
          x="0"
          y="0"
          width="313"
          height="128"
          maskUnits="userSpaceOnUse"
        >
          <rect width="313" height="128" rx="6" fill="white" />
        </mask>
      </defs>
    </g>
  );
};

const ScanningPackageAnalysis = () => {
  const [activeIndex, setActiveIndex] = useState({
    id: 0,
    phase1: false,
    phase2: false,
  });

  const timerRef = useRef(null);

  useEffect(() => {
    let currentId = 0;
    const iconsLength = Object.keys(iconsMap).length;

    timerRef.current = setInterval(() => {
      const id = currentId;

      setActiveIndex({
        id,
        phase1: true,
        phase2: false,
      });

      setTimeout(() => {
        setActiveIndex({
          id,
          phase1: false,
          phase2: true,
        });
      }, FIRST_TIME * 1000);

      currentId = (currentId + 1) % iconsLength;
    }, TIME * 1000);

    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <Explainer
      width={EXPLANER_WIDTH}
      height={EXPLANER_HEIGHT}
      background={
        'radial-gradient(126.67% 89.92% at 86.62% 96.62%, #082D55 0%, rgba(18, 50, 86, 0.00) 100%), radial-gradient(97.62% 86.9% at 30.18% 108.24%, #124884 0%, rgba(23, 59, 101, 0.00) 100%), var(--base-color-grey-1000)'
      }
    >
      <g
        className={cn(styles.root)}
        style={{
          '--scanning-time': `${FIRST_TIME + EASE * 2}s`,
          '--scanning-ease': `${EASE}s`,
        }}
      >
        <g className={cn(styles.wrapper)}>
          <g className={cn(styles.packages)}>
            {Object.values(iconsMap).map((icon, i) => (
              <Package
                key={i}
                index={i}
                icon={icon}
                result={icon.result}
                status={activeIndex.id === i && activeIndex.phase1 ? 1 : 0}
              />
            ))}
          </g>
          <StatusMonitor
            status={
              activeIndex.phase2
                ? iconsMap[activeIndex.id].result.color
                : 'scanning'
            }
            headline={
              activeIndex.phase2 ? iconsMap[activeIndex.id].result.value : ''
            }
          />
        </g>
      </g>
    </Explainer>
  );
};

export default ScanningPackageAnalysis;
